/**
 * 客户端Nuxt公共函数、插件, 可以直接加$前缀使用
 */
// import 'amfe-flexible';
import { loginGoogle, loginFacebook, type ILoginFacebook, setUrlCache } from '@/api/models/system'
import { getShipingCartTotal } from '@/api/models/userInfo'
import { $http } from '@/api/request'
import { sensorsTrack, getSensorsInstance, sensorsLogin,  SENSORS_EVENT, registerSuccessTrack } from './sensors.client'
import {
  getHotKeysJumpUrl,
  getListingDetailHref,
  toListingDetail,
  buildHomeBannerSource,
  applySourceLatestPage,
  appendQueryToUrl,
  isMarketingCmsUrl,
  withMarketingCmsSource,
  MARKETING_CMS_LATEST_PAGE,
  type ICmsGoToOptions
} from './utils'
import { customEventFn, eventName } from '@/plugins/bi-sa.client'
import { getUserProfile } from '@/api/models/userInfo'
import { loadScript, type ILoadJsOptions } from '../utils/script-loader'
export type { ILoadJsOptions } from '../utils/script-loader'

export const openFn = (method: string, url: string, data: any) => {
  const form = document.createElement('form')
  form.action = url
  form.method = method
  form.target = '_self'
  if (data) {
    for (const key in data) {
      if (data[key]) {
        const input = document.createElement('input')
        input.name = key
        input.value = typeof data[key] === 'object'
          ? JSON.stringify(data[key])
          : data[key]
        form.appendChild(input)
      }
    }
  }
  form.style.display = 'none'
  document.body.appendChild(form)
  form.submit()
}

export const getRedirectPath = (path?: string):string => {
  let url = window.location.href

  if(window.location.href.indexOf('?redirect=') > -1) {
    const params = url.split('?redirect=')
    url = params[1]
    // CPS uses a router query value: decode the outer redirect once, while
    // preserving encoding inside the product URL and legacy raw redirects.
    const redirect = new URL(window.location.href).searchParams.get('redirect')
    if (redirect?.startsWith('/listing/')) {
      const target = new URL(redirect, window.location.origin)
      if (target.searchParams.get('cpsShareAsset')) {
        url = redirect
      }
    }
  } else {
    // 注册/登陆成功后无特殊情况默认跳转首页
    url = path || '/'
  }

  return url
}

// interface ILoadJsOptions { id?: string }
// const setUserInfo = (useInfo: IUserInfo, path?: string, notJump?: boolean) => {
export const setUserInfo = async(
  useInfo: IUserInfo,
  path?: string,
  notJump?: boolean,
  isFromThirdApp?: boolean
) => {
  if(typeof window.ssq !== 'undefined') {
    window.ssq.push('clearUser')
  }
  
  useCookie<IUserInfo>('UserInfo').value = useInfo
  useUserInfo().value = useInfo

  try {
    const r = await getUserProfile()
    useInfo.profile = { ...useInfo.profile, ...r }
    useCookie<IUserInfo>('UserInfo').value = useInfo
    useUserInfo().value = useInfo
  } catch (error) {
    console.log('error: ', error)
  }

  const { isExistAccount, isRegister } = useInfo

  if(((!isExistAccount) && isFromThirdApp) || (isRegister)) {
    const { userId, nick } = useInfo
    // 注册成功
    window.ttq.track('CompleteRegistration', {
      "contents": [
          {
              "content_id": String(userId), // string. ID of the product. Example: "1077218".
              "content_type": nick, // string. Either product or product_group.
              "content_name": "" // string. The name of the page or product. Example: "shirt".
          }
      ],
      "value": 0, // number. Value of the order or items sold. Example: 100.
      "currency": 'KES' // string. The 4217 currency code. Example: "USD".
  });
  }
  // 通知老Wap进行页面跳转， 并且要考虑是否带有redirect回跳函数
  if(!notJump) {
    let _path: string = '/'
    if('isSetPwd' in useInfo && useInfo.isSetPwd === false) {
      _path = `/set-pwd?${window.location.search}`
    }
    const url = getRedirectPath(path || _path)

    // CMS
    if(/\/special\//.test(url)) {
      window.location.href = `${window.location.origin}${url}`
    } else {
      requestAnimationFrame(() => {
        window.location.href = url
      })
      // useRouter().replace(url)
    }
  }

  // 登录时增加购物车数量（加延时为了等待Token写完）
  setTimeout(() => {
    getShipingCartTotal().then((r: any) => {
      useShopingCartTotal().value = r?.count || 0
    })

    sensorsLogin(getSensorsInstance())
  }, 20)
}

// export const openApp = (data: any, type: number = 5) => {
//   /** 本身就是再App内打开的，则直接返回 */
//   if(useIsAndroid().value || useIsFlutterApp().value) {
//     return
//   }
//   /** 如果不是移动端 */
//   if(!useIsMobile().value) {
//     return
//   }

//   useRequestLoading().value = true
//   const ifr = document.createElement('iframe')

//   ifr.src = `https://www.kilimall.co.ke/deepLink?type=${type}&data=${data}`
//   // ifr.src = `kiliapp://net.kilimall.shop/deepLink?type=${type}&data=${data}`
//   ifr.style.display = 'none'

//   document.body.appendChild(ifr)

//   setTimeout(() => {
//     if(document.visibilityState === 'visible') {
//       window.open('https://play.google.com/store/apps/details?id=net.kilimall.shop')
//     }

//     useRequestLoading().value = false
//   }, 2000)
// }

const googleLogin = async(idToken: string) => {
  const userInfo = await loginGoogle(idToken)

  sensorsTrack(getSensorsInstance())(SENSORS_EVENT.LoginSuccess, { LoginMethod: 'google' })

  if(!userInfo.isExistAccount || userInfo.isRegister) {
    registerSuccessTrack('google')
    customEventFn(eventName.registerSuccess,  { register_method: 'google',  register_source: 'normal'})
  }
  await setUserInfo(userInfo, '', false, true)
}

const facebookLogin = async(loginParams: ILoginFacebook) => {
  const userInfo = await loginFacebook(loginParams)
  
  if(!userInfo.isExistAccount || userInfo.isRegister) {
    registerSuccessTrack('facebook')
    customEventFn(eventName.registerSuccess,  { register_method: 'facebook',  register_source: 'normal'})
  }

  sensorsTrack(getSensorsInstance())(SENSORS_EVENT.LoginSuccess, { LoginMethod: 'facebook' })
  await setUserInfo(userInfo, '', false, true)
}

export const asyncLoadJs = (url: string, options?: ILoadJsOptions): Promise<any> => loadScript(url, options)

/* app进入,隐藏顶部标题 */
export const displayHeaderBar = (title: string) => {
  if(useIsFlutterApp().value) {
    window.flutter_inappwebview.callHandler('setTitle', title)
  }
  if(useIsAndroid().value) {
    window.androidWebObject.setTitle( title)
  }
  return 
}

export const openAftersaleReturn = (aftersaleId: string, expressType: string) => {
  if (useIsAndroid().value && window.androidWebObject && window.androidWebObject.openAftersaleReturnPickStation) {
    window.androidWebObject.openAftersaleReturnPickStation(aftersaleId, expressType)
  } else {
    throw new Error('openAftersaleReturnPickStation not found on app')
  }
}
const switchCountry = async(item: region.IRegionItem) => {
  showLoadingToast('loading')

  const p = {
    regionId: item.id,
    userInfo: useUserInfo().value,
    domain: item.domain
  }

  const { url } = await $http.post({ url: `${window.location.origin}/api/set-token`, body: p, loading: false }).then((r: any) => r.data)

  window.location.href = url
}

const parseLogisticsStr = (str: string): string => {
  const pattern = /\[{3}(.*?)\]{3}/g
  const results = str.match(pattern)
  if (!results) return str
  let params
  let htmStr
  results.forEach((item) => {
    params = item.replace(/\[{3}|\]{3}/g, '').split('|||')
    htmStr = `<span style="color:${params[2]}">${params[0]
      .replace('\\[\\', '[')
      .replace('\\]\\', ']')}</span>`
    str = str.replace(/\[{3}(.*?)\]{3}/, htmStr)
  })
  return str
}

const isAndroid = (): boolean => useIsAndroid().value
const initOpenByFlutter = async() => {
  const ui = await window.flutter_inappwebview.callHandler('getAuthInfo')
  useCookie('UserInfo').value = ui
  const rid = await window.flutter_inappwebview.callHandler('getRegionId')
  useCookie('regionId').value = rid

  useUserInfo().value = ui ? JSON.parse(ui) : null
}

const copyText = (text: string): void => {
//   if (navigator.clipboard) {
//     // clipboard api 复制
//     navigator.clipboard.writeText(text);
// } else {
    var input = document.createElement('input');
    document.body.appendChild(input);
    // 隐藏此输入框
    input.style.height = '0px'
    input.style.opacity = '0'
    // 赋值
    input.value = text;
    // 选中
    input.select();
    // 复制
    document.execCommand('copy', true);
    // 移除输入框
    document.body.removeChild(input);
  // }
}

const cmsStoreJump = (
  type: 'key' | 'product' | 'category' | 'url',
  data: string,
  config: {
    storeId?: number,
    source?: string
  }
) => {
  const router = useRouter()
  const { storeId, source='' } = config

  if(type === 'key') {
    router.push(`/search?q=${data}&storeId=${storeId}&source=${source}`)
  } else if(type === 'product') {
    toListingDetail(Number(data), { source })
  } else if(type === 'category') {
    router.push(`/search?storeId=${storeId}&storeCategoryIds=${data}&source=${source}`)
  } else if(type === 'url') {
    // 专题页 /special、/c：沿用店铺 CMS 已组好的前 4 段，latestPage 固定 marketingCms
    window.location.href = withMarketingCmsSource(data, source)
  }
}

const isFlutterApp = (): boolean => useIsFlutterApp().value

export default defineNuxtPlugin((NuxtApp) => {
  return {
    provide: {
      openFn,
      setUserInfo,
      getRedirectPath,
      googleLogin,
      facebookLogin,
      asyncLoadJs,
      isAndroid,
      isFlutterApp,
      switchCountry,
      parseLogisticsStr,
      copyText,
      displayHeaderBar,
      initOpenByFlutter,
      openAftersaleReturn,
      /**
       * 配置项跳转
       * @param type 跳转类型
       * @param data 跳转value
       */
      cmsGoTo: async(type: string, data: string, options?: ICmsGoToOptions) => {
          const router = useRouter()
          if(!data) return false
          const trackSourceValueMpa: IAnyObject = {
            key: `search_${data}`,
            product: 'ProductDetails',
            store: `Store_${data}`,
            category: `Category_${data}`,
            brand: `Brand_${data}`
          }

          let tmpUrl = '';
          let query: any = {}
          if (options?.trafficSourceScene === 'homeMainIconBanner') {
            query.source = buildHomeBannerSource('mainIconBanner', options.sourceValue || '', type)
          } else if (options?.trafficSourceScene === 'homeCenterBanner') {
            query.source = buildHomeBannerSource('centerBanner', options.sourceValue || '', type)
          } else {
            query.source = `homePage|mainIcon|${trackSourceValueMpa[type] || ''}`
          }
          switch (type) {
            case "key":  // 搜索关键词- 商品名称
              tmpUrl = '/search' // ?keyword=' + data
              query.q = data
              break;
            case "url":  // URL链接跳转
              const [url, queryStr] = data.split('?')

              if(data.indexOf('http://') == -1 && data.indexOf('https://') == -1 && queryStr) {
                // url 不包括http时, 转换成路由参数
                const strs = queryStr.split('&')
                strs.forEach((c: string) => {
                  const [k, v] = c.split('=')
                  query[k] = v
                })
                tmpUrl = url
              } else {
                tmpUrl = data
              }
              break;
            case "product":  // 商品listingID
              const { url: _url, key, cookie } = getListingDetailHref(Number(data), { source: query.source })
              tmpUrl = `${location.origin}${_url}`
              await setUrlCache(cookie, key)
              
              break
            case "store":  // 店铺ID
              tmpUrl = `/store/${data}`
              break;
            case "category":  // 品类ID
              tmpUrl = `/search?id=${data}&from=category`
              query.id = data
              break;
            case "brand": // 品牌ID
              tmpUrl = `/search` // ?brandIds=${data}`
              query.brandIds = data
              break;
            case "special":  // 专题ID
              tmpUrl = `${window.location.origin}/special/${data}`
              break
          }
          
          // 专题页 /special、/c：前 4 段沿用原 source，latestPage 固定 marketingCms
          const jumpToMarketingCms = type === 'special' || isMarketingCmsUrl(tmpUrl) || isMarketingCmsUrl(data)
          if (jumpToMarketingCms && query.source) {
            query.source = applySourceLatestPage(query.source, MARKETING_CMS_LATEST_PAGE)
          }

          if(tmpUrl.indexOf('http://') == -1 && tmpUrl.indexOf('https://') == -1) {
            // 路由跳转
            router.push({ path: tmpUrl, query })
          } else { // url 跳转（绝对地址需手动拼 source）
            let finalUrl = /^http(s)?:\/\/.*/.test(tmpUrl) ? tmpUrl : data
            if (jumpToMarketingCms && query.source) {
              finalUrl = appendQueryToUrl(finalUrl, { source: query.source })
            }
            window.location.href = finalUrl
          }
      },
      cmsStoreJump,
      /**
       [
          { "id": 1, "name": "URL" },
          { "id": 2, "name": "搜索关键词结果页" },
          { "id": 3, "name": "类目结果页【前端】" },
          { "id": 4, "name": "其他页面" },
          { "id": 5, "name": "商详页(Listing ID)" },
          { "id": 6, "name": "店铺页" },
          { "id": 7, "name": "品牌页" },
          { "id": 8, "name": "订单详情页" },
          { "id": 9, "name": "售后详情页" },
          { "id": 10, "name": "商详页(SKU ID)" }
      ]
       * item: { linkType, linkValue }
      */
      hotKeysJump(
        item: { linkType: any, linkValue: any, keyword?: string },
        isTrack: boolean = true, // 是否埋点
        trackSource?: string
      ) {
        const router = useRouter()
        // 真正跳转时再写 cache；避免 PC 顶栏热搜 :href 渲染时刷 set-params
        const { raw, href, cacheWrite } = getHotKeysJumpUrl(item, isTrack, trackSource, { writeCache: true })

        // 绝对 URL（含专题页）：整页跳转，source 已在 getHotKeysJumpUrl 中处理
        if (/^http(s)?:\/\//.test(href) || /^http(s)?:\/\//.test(item.linkValue)) {
          const jumpUrl = href || withMarketingCmsSource(item.linkValue, trackSource)
          window.location.href = jumpUrl
          return
        }

        const path = raw || href
        if(!path) {
          console.info('不支持该类型跳转', item.linkType, item.linkValue)
          return
        }

        const navigate = () => {
          if([2, 3].includes(item.linkType)) {
            router.push(path)

            if(/\/search-result\?|\/search\?|\/category\/[0-9a-zA-Z\-]+\?/.test(location.pathname)) {
              setTimeout(() => { window.location.reload() }, 20)
            }
          } else if (typeof path === 'string' && isMarketingCmsUrl(path)) {
            // 相对路径专题页：router.push 对站外/专属路由可能无效，整页跳转
            window.location.href = path.startsWith('http') ? path : `${location.origin}${path}`
          } else {
            router.push(path)
          }
        }

        // 商详需等 url-cache 写入 source 后再跳转
        if (cacheWrite) {
          cacheWrite.finally(navigate)
        } else {
          navigate()
        }
      }
    }
  }
})
